angular
  .module('bb.notifications')
  .factory('listingNotificationSettings', listingNotificationSettings);

listingNotificationSettings.$inject = ['$resource'];
function listingNotificationSettings($resource) {
  const ListingNotifications = $resource(
    '/external/listing/:retsId/notifications',
    {
      retsId: '@retsId',
      email: '@uid',
    },
  );

  const DashNotifications = $resource(
    '/external/dash/:dashboardId/notifications',
    {
      dashboardId: '@dashboardId',
    },
  );

  function get(retsId) {
    return ListingNotifications.get({ retsId }).$promise;
  }

  function save(retsId, notifications) {
    return ListingNotifications.save({ retsId }, notifications).$promise;
  }

  function getDash(dashboardId, appointmentId) {
    return DashNotifications.get({ dashboardId, appointmentId }).$promise;
  }

  function saveDash(dashboardId, notifications) {
    return DashNotifications.save({ dashboardId }, notifications).$promise;
  }

  return {
    get,
    save,
    getDash,
    saveDash,
  };
}

export {};
